import { ComponentRef, DestroyRef, ViewContainerRef } from '@angular/core';
import { IActionCenterSuggester, IActionHandler, IAiSuggestActions } from '../interfaces';
import { SmartSuggestSelectorComponent } from '../components/smart-suggest-selector/smart-suggest-selector.component';
import { AiSuggestionsFactory } from '../actions/ai-suggest/factory';
import { Observable } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActionCenterService } from '@app/core/services/action-center.service';

export class SmartSuggestActionHandler implements IActionHandler {
	constructor(
		private actionCenterService: ActionCenterService,
		private viewContainerRef: ViewContainerRef,
		private suggestFactory: AiSuggestionsFactory,
		private destroyRef: DestroyRef
	) {}

	private openSuggestionComponent(): ComponentRef<SmartSuggestSelectorComponent> {
		return this.viewContainerRef.createComponent(SmartSuggestSelectorComponent);
	}

	private getSuggestionSelectionEmitter(
		selectionComponent: ComponentRef<SmartSuggestSelectorComponent>
	): Observable<IAiSuggestActions> {
		return selectionComponent.instance.emitSuggestion;
	}

	private async startSuggesting(suggester: IActionCenterSuggester): Promise<void> {
		await suggester.suggest(
			this.actionCenterService.selectedEntities.map(entity =>
				entity.pk ? entity.pk : entity
			)
		);
	}
	//Should get config, but config is not necessesary here.
	//TS handles getting args where it shouldnt get args
	handleAction(): void {
		const suggestionSelectorComponent = this.openSuggestionComponent();
		const suggestionObs = this.getSuggestionSelectionEmitter(suggestionSelectorComponent);
		this.actionCenterService.enableApplyButton$.next(false);

		suggestionObs.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(suggestion => {
			const suggester = this.suggestFactory.createSuggester(
				this.actionCenterService.tableType.value,
				suggestion
			);
			this.startSuggesting(suggester);
			this.actionCenterService.closeActionCenter$.next();
		});
	}
}
